import { type AttributeSet } from "@/schemas/attribute/AttributeSet";

export enum EventAttributeType {
  CATEGORY = "event_category",
  STATUS = "event_status",
  LOCATION = "event_location",
}

export type EventAttributeSet = AttributeSet<EventAttributeType>;
